import React, { useState, useEffect } from "react";
import CustomDateRangePicker from "./CustomDateRangePicker";
import PeriodSelector from "./PeriodSelector";

const DEFAULT_PERIODS = [
  { label: "Max", value: "max" },
  { label: "Year", value: "year" },
  { label: "Month", value: "month" },
  { label: "Week", value: "week" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Day", value: "day" },
  { label: "Custom", value: "custom" },
];

export const startOfDay = (date = new Date()) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const endOfDay = (date = new Date()) => {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
};

const subtractDate = (amount, period) => {
  const d = new Date();

  switch (period) {
    case "year":
      d.setFullYear(d.getFullYear() - amount);
      break;
    case "month":
      const originalDay = d.getDate();
      d.setMonth(d.getMonth() - amount);
      if (d.getDate() !== originalDay) {
        d.setDate(0);
      }
      break;
    case "day":
      d.setDate(d.getDate() - amount);
      break;
    default:
      return null;
  }

  return startOfDay(d);
};

const PERIOD_HANDLERS = {
  max: () => startOfDay(new Date(2000, 0, 1)),
  year: () => subtractDate(1, "year"),
  month: () => subtractDate(1, "month"),
  week: () => subtractDate(7, "day"),
  yesterday: () => subtractDate(1, "day"),
  day: () => startOfDay(),
};

export const getDateRangeByPeriod = (period) => {
  if (period === "custom" || !PERIOD_HANDLERS[period]) return null;

  const startDate = PERIOD_HANDLERS[period]();
  let endDate = new Date();

  if (period === "yesterday") {
    endDate = endOfDay(startDate);
  }

  return {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
  };
};

export default function DateRangeSelector({
  periods = DEFAULT_PERIODS,
  defaultPeriod = "day",
  onChange,
}) {
  const [period, setPeriod] = useState(defaultPeriod);
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  useEffect(() => {
    if (period === "custom") {
      if (customFrom && customTo) {
        const start = startOfDay(new Date(customFrom));
        const end = endOfDay(new Date(customTo));

        onChange?.({
          period,
          start_date: start.toISOString(),
          end_date: end.toISOString(),
        });
      }
      return;
    }

    const range = getDateRangeByPeriod(period);
    if (range) {
      onChange?.({ period, ...range });
    }
  }, [period, customFrom, customTo]);

  return (
    <div>
      <PeriodSelector
        selectedPeriod={period}
        onChange={(e) => setPeriod(e.target.value)}
        periods={periods}
      />

      {period === "custom" && (
        <CustomDateRangePicker
          customFrom={customFrom}
          customTo={customTo}
          setCustomFrom={setCustomFrom}
          setCustomTo={setCustomTo}
        />
      )}
    </div>
  );
}
